import { FC } from 'react'
import { keyframes } from '@emotion/react'
import styled from '@emotion/styled/macro'
import theme from 'theme'

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

const SpinnerSvg = styled.svg`
  animation: ${spin} 1s linear infinite;

  html[data-theme='light'] & line {
    stroke: ${theme.colors.dropdownLabel};
  }
`

interface IconProps {
  className?: string
  size?: number
}

export const MetaDataIcon: FC<IconProps> = ({ className, size = 18 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.4525 5.22041L9 9.00792L15.5475 5.22041M9 16.5604V9.00042M15.75 12.0004V6.00041C15.7497 5.73737 15.6803 5.47902 15.5487 5.25129C15.417 5.02355 15.2278 4.83444 15 4.70291L9.75 1.70291C9.52197 1.57126 9.2633 1.50195 9 1.50195C8.7367 1.50195 8.47803 1.57126 8.25 1.70291L3 4.70291C2.7722 4.83444 2.58299 5.02355 2.45135 5.25129C2.31971 5.47902 2.25027 5.73737 2.25 6.00041V12.0004C2.25027 12.2635 2.31971 12.5218 2.45135 12.7495C2.58299 12.9773 2.7722 13.1664 3 13.2979L8.25 16.2979C8.47803 16.4296 8.7367 16.4989 9 16.4989C9.2633 16.4989 9.52197 16.4296 9.75 16.2979L15 13.2979C15.2278 13.1664 15.417 12.9773 15.5487 12.7495C15.6803 12.5218 15.7497 12.2635 15.75 12.0004Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const PerformanceIcon: FC<IconProps> = ({ className, size = 18 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.6875 13.4998L6.75 8.43732L9.97982 11.6671C10.8826 9.89091 12.3781 8.40155 14.3402 7.52798L16.3957 6.61282M16.3957 6.61282L11.9397 4.90234M16.3957 6.61282L14.6852 11.0688"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const BenchmarkingIcon: FC<IconProps> = ({ className, size = 18 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 2.25V15.1875M9 15.1875C7.896 15.1875 6.83843 15.3863 5.86112 15.75M9 15.1875C10.104 15.1875 11.1616 15.3863 12.1389 15.75M14.0625 3.72817C12.4084 3.49538 10.7183 3.375 9 3.375C7.28173 3.375 5.59157 3.49538 3.9375 3.72817M14.0625 3.72817C14.8203 3.83482 15.5706 3.96508 16.3125 4.11815M14.0625 3.72817L16.0278 11.7721C16.1192 12.1461 15.9481 12.5428 15.5859 12.6731C15.1101 12.8442 14.5972 12.9375 14.0625 12.9375C13.5278 12.9375 13.0149 12.8442 12.5391 12.6731C12.1769 12.5428 12.0058 12.1461 12.0972 11.7721L14.0625 3.72817ZM1.6875 4.11815C2.42941 3.96508 3.17967 3.83482 3.9375 3.72817M3.9375 3.72817L5.90277 11.7721C5.99415 12.1461 5.82314 12.5428 5.46085 12.6731C4.9851 12.8442 4.47219 12.9375 3.9375 12.9375C3.40281 12.9375 2.8899 12.8442 2.41415 12.6731C2.05186 12.5428 1.88085 12.1461 1.97223 11.7721L3.9375 3.72817Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const InsightsIcon: FC<IconProps> = ({ className, size = 20 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 15V10.625M10 10.625C10.4316 10.625 10.8505 10.5704 11.25 10.4675M10 10.625C9.56838 10.625 9.14953 10.5704 8.75 10.4675M11.875 16.6995C11.2677 16.8147 10.6409 16.875 10 16.875C9.35913 16.875 8.73235 16.8147 8.125 16.6995M11.25 18.685C10.8392 18.728 10.4222 18.75 10 18.75C9.57783 18.75 9.1608 18.728 8.75 18.685M11.875 15V14.8403C11.875 14.0212 12.4236 13.3209 13.132 12.9098C14.9963 11.8281 16.25 9.81048 16.25 7.5C16.25 4.04822 13.4518 1.25 10 1.25C6.54822 1.25 3.75 4.04822 3.75 7.5C3.75 9.81048 5.00371 11.8281 6.86796 12.9098C7.57644 13.3209 8.125 14.0212 8.125 14.8403V15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const LabelsIcon: FC<IconProps> = ({ className, size = 18 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.07376 14.9262C4.17211 16.0246 5.95289 16.0246 7.05124 14.9262L11.8525 10.125M5.0625 15.75C3.5092 15.75 2.25 14.4908 2.25 12.9375V3.09375C2.25 2.62776 2.62776 2.25 3.09375 2.25H7.03125C7.49724 2.25 7.875 2.62776 7.875 3.09375V6.14753M5.0625 15.75C6.6158 15.75 7.875 14.4908 7.875 12.9375V6.14753M5.0625 15.75H14.9062C15.3722 15.75 15.75 15.3722 15.75 14.9062V10.9688C15.75 10.5028 15.3722 10.125 14.9062 10.125H11.8525M7.875 6.14753L10.0343 3.98818C10.3638 3.65868 10.8981 3.65868 11.2276 3.98818L14.0118 6.77241C14.3413 7.10192 14.3413 7.63615 14.0118 7.96566L11.8525 10.125M5.0625 12.9375H5.06813V12.9431H5.0625V12.9375Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const CPIsIcon: FC<IconProps> = ({ className, size = 18 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.25 9.84375C2.25 9.37776 2.62776 9 3.09375 9H4.78125C5.24724 9 5.625 9.37776 5.625 9.84375V14.9062C5.625 15.3722 5.24724 15.75 4.78125 15.75H3.09375C2.62776 15.75 2.25 15.3722 2.25 14.9062V9.84375Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.3125 6.46875C7.3125 6.00276 7.69026 5.625 8.15625 5.625H9.84375C10.3097 5.625 10.6875 6.00276 10.6875 6.46875V14.9062C10.6875 15.3722 10.3097 15.75 9.84375 15.75H8.15625C7.69026 15.75 7.3125 15.3722 7.3125 14.9062V6.46875Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.375 3.09375C12.375 2.62776 12.7528 2.25 13.2188 2.25H14.9062C15.3722 2.25 15.75 2.62776 15.75 3.09375V14.9062C15.75 15.3722 15.3722 15.75 14.9062 15.75H13.2188C12.7528 15.75 12.375 15.3722 12.375 14.9062V3.09375Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const InfoIcon: FC<IconProps> = ({ className, size = 16 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 7.5L7.52766 7.48617C7.90974 7.29513 8.33994 7.64023 8.23634 8.05465L7.76366 9.94535C7.66006 10.3598 8.09026 10.7049 8.47234 10.5138L8.5 10.5M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM8 5.5H8.005V5.505H8V5.5Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

/* Label type icons - from Figma */

export const LabelInstanceAddedIcon: FC<IconProps> = ({ className, size = 20 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 7.5V12.5M12.5 10H7.5M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const LabelInstanceRemovedIcon: FC<IconProps> = ({ className, size = 20 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 10H7.5M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const LabelSLAChangedIcon: FC<IconProps> = ({ className, size = 20 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3523 7.79001H17.5128V7.78853M2.48682 16.37V12.2095M2.48682 12.2095L6.64735 12.2095M2.48682 12.2095L5.13756 14.8619C5.963 15.6889 7.01054 16.3163 8.22034 16.6405C11.8879 17.6232 15.6577 15.4467 16.6405 11.7791M3.35898 8.22037C4.3417 4.55279 8.11152 2.37629 11.7791 3.35901C12.9889 3.68318 14.0365 4.31061 14.8619 5.13759L17.5128 7.78853M17.5128 3.62951V7.78853"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const LabelCPIActivatedIcon: FC<IconProps> = ({ className, size = 20 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1666 5H5.83325C4.50717 5 3.2354 5.52678 2.29772 6.46447C1.36004 7.40215 0.833252 8.67392 0.833252 10C0.833252 11.3261 1.36004 12.5979 2.29772 13.5355C3.2354 14.4732 4.50717 15 5.83325 15H14.1666C15.4927 15 16.7644 14.4732 17.7021 13.5355C18.6398 12.5979 19.1666 11.3261 19.1666 10C19.1666 8.67392 18.6398 7.40215 17.7021 6.46447C16.7644 5.52678 15.4927 5 14.1666 5Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M14.1667 12.5C14.8298 12.5 15.4657 12.2366 15.9345 11.7678C16.4034 11.2989 16.6667 10.663 16.6667 10C16.6667 9.33696 16.4034 8.70107 15.9345 8.23223C15.4657 7.76339 14.8298 7.5 14.1667 7.5C13.5037 7.5 12.8678 7.76339 12.399 8.23223C11.9301 8.70107 11.6667 9.33696 11.6667 10C11.6667 10.663 11.9301 11.2989 12.399 11.7678C12.8678 12.2366 13.5037 12.5 14.1667 12.5Z"
      fill="currentColor"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
  </svg>
)

export const LabelPublicIcon: FC<IconProps> = ({ className, size = 16 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 12.4794C12.165 12.4931 12.3319 12.5 12.5004 12.5C13.1993 12.5 13.8703 12.3805 14.494 12.1608C14.4982 12.1078 14.5004 12.0541 14.5004 12C14.5004 10.8954 13.605 10 12.5004 10C12.082 10 11.6936 10.1285 11.3725 10.3482M12 12.4794C12 12.4863 12 12.4931 12 12.5C12 12.65 11.9917 12.7981 11.9757 12.9438C10.8045 13.6158 9.44711 14 8 14C6.55289 14 5.19551 13.6158 4.02434 12.9438C4.00826 12.7981 4 12.65 4 12.5C4 12.4932 4.00002 12.4863 4.00005 12.4795M12 12.4794C11.996 11.6951 11.7663 10.9641 11.3725 10.3482M11.3725 10.3482C10.6619 9.23679 9.41698 8.5 8 8.5C6.5832 8.5 5.33844 9.23661 4.62779 10.3477M4.62779 10.3477C4.30682 10.1283 3.91864 10 3.50049 10C2.39592 10 1.50049 10.8954 1.50049 12C1.50049 12.0541 1.50264 12.1078 1.50686 12.1608C2.13062 12.3805 2.8016 12.5 3.50049 12.5C3.66872 12.5 3.83533 12.4931 4.00005 12.4795M4.62779 10.3477C4.2338 10.9638 4.00399 11.6949 4.00005 12.4795M10 4.5C10 5.60457 9.10457 6.5 8 6.5C6.89543 6.5 6 5.60457 6 4.5C6 3.39543 6.89543 2.5 8 2.5C9.10457 2.5 10 3.39543 10 4.5ZM14 6.5C14 7.32843 13.3284 8 12.5 8C11.6716 8 11 7.32843 11 6.5C11 5.67157 11.6716 5 12.5 5C13.3284 5 14 5.67157 14 6.5ZM5 6.5C5 7.32843 4.32843 8 3.5 8C2.67157 8 2 7.32843 2 6.5C2 5.67157 2.67157 5 3.5 5C4.32843 5 5 5.67157 5 6.5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const LabelPrivateIcon: FC<IconProps> = ({ className, size = 16 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 7V4.5C11 2.84315 9.65685 1.5 8 1.5C6.34315 1.5 5 2.84315 5 4.5V7M4.5 14.5H11.5C12.3284 14.5 13 13.8284 13 13V8.5C13 7.67157 12.3284 7 11.5 7H4.5C3.67157 7 3 7.67157 3 8.5V13C3 13.8284 3.67157 14.5 4.5 14.5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const LabelCustomIcon: FC<IconProps> = ({ className, size = 20 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.97335 2.5H4.375C3.33947 2.5 2.5 3.33947 2.5 4.375V7.97335C2.5 8.47063 2.69754 8.94754 3.04917 9.29917L11.0334 17.2834C11.6157 17.8657 12.5166 18.0098 13.2054 17.5587C14.9392 16.4237 16.4237 14.9392 17.5587 13.2054C18.0098 12.5166 17.8657 11.6157 17.2834 11.0334L9.29917 3.04917C8.94754 2.69754 8.47063 2.5 7.97335 2.5Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 5H5.00625V5.00625H5V5Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const LoadingSpinner: FC<IconProps> = ({ className, size = 24 }) => (
  <SpinnerSvg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line x1="12" y1="2" x2="12" y2="6" stroke="#E9E0E4" strokeWidth="2" strokeLinecap="round" opacity="1" />
    <line x1="12" y1="18" x2="12" y2="22" stroke="#E9E0E4" strokeWidth="2" strokeLinecap="round" opacity="0.15" />
    <line x1="4.93" y1="4.93" x2="7.76" y2="7.76" stroke="#E9E0E4" strokeWidth="2" strokeLinecap="round" opacity="0.85" />
    <line x1="16.24" y1="16.24" x2="19.07" y2="19.07" stroke="#E9E0E4" strokeWidth="2" strokeLinecap="round" opacity="0.25" />
    <line x1="2" y1="12" x2="6" y2="12" stroke="#E9E0E4" strokeWidth="2" strokeLinecap="round" opacity="0.7" />
    <line x1="18" y1="12" x2="22" y2="12" stroke="#E9E0E4" strokeWidth="2" strokeLinecap="round" opacity="0.3" />
    <line x1="4.93" y1="19.07" x2="7.76" y2="16.24" stroke="#E9E0E4" strokeWidth="2" strokeLinecap="round" opacity="0.55" />
    <line x1="16.24" y1="7.76" x2="19.07" y2="4.93" stroke="#E9E0E4" strokeWidth="2" strokeLinecap="round" opacity="0.4" />
  </SpinnerSvg>
)
